import { useSelector } from "react-redux";

const MANUAL = "/api/manual";
const SNB = "/api/snb";

const api = {
  manual: {
    select: MANUAL + "/select/manual",
    search: MANUAL + "/select/manual/search",
    represent: MANUAL + "/select/manual/represent",
  },
  snb: {
    select: SNB + "/all/manual",
  },
};

export default api;
